<template>
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5">
        <rect x="5.5" y="5.5" width="7" height="7" rx="1.5" />
        <path d="M10.5 5.5V4a1.5 1.5 0 0 0-1.5-1.5H4A1.5 1.5 0 0 0 2.5 4v5A1.5 1.5 0 0 0 4 10.5h1.5" />
    </svg>
</template>

<script lang="ts" setup vapor>
defineOptions({ name: 'CopyIcon' });
</script>
